import React from "react";

import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import { ConfigurationStore } from "stores";

import { IntlContext } from "intl";

const LanguageSwitch: React.FC = (): JSX.Element | null => {
  const { locale, setLocale } = React.useContext(IntlContext);

  const configuration = React.useContext(ConfigurationStore);
  const allowedLocales = configuration.intl?.allowedLocales || ["de"];

  const handleChange = (event: SelectChangeEvent) => {
    setLocale(event.target.value as string);
  };

  if (!allowedLocales || allowedLocales.length === 1) return null;

  return (
    <FormControl>
      <InputLabel
        className="aria-hidden"
        id="labelForLanguageSwitch"
        htmlFor="languageSwitch"
      >
        Age
      </InputLabel>
      <Select
        sx={{
          height: 40,
          borderRadius: 1,
          backgroundColor: "grey.400",
        }}
        value={locale}
        onChange={handleChange}
        labelId="labelForLanguageSwitch"
        id="languageSwitch"
      >
        {allowedLocales.map((lang: string) => (
          <MenuItem key={lang} value={lang}>
            {lang}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSwitch;
